module.exports = __webpack_public_path__ + "static/banner-mobile-76b9b654697904b4f5830c6dbc2daf0b.png";